let defaultPortalSelector = () => document.body;
export const getDefaultPortalSelector = () => defaultPortalSelector;
export const setDefaultPortalSelector = selector =>
  (defaultPortalSelector = selector);
